<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
  filteredTags: (selectableTags$ | async) ?? [],
  selectedTags: (selectedTags$ | async) ?? [],
  editingTag: (editingTag$ | async) ?? null
}"> </ng-container>


<ng-template #template let-filteredTags="filteredTags" let-selectedTags="selectedTags" let-editingTag="editingTag">
  <div class="menu-section">
    <div flexLayout="column" flexLayoutAlign="start stretch">
      <div *ngFor="let tag of selectedTags; trackBy: trackTagById" [class.editing]="editingTag?.tagId === tag.tagId"
        class="menu-item selected" flexLayout="row" flexLayoutAlign="space-between center">
        <div>{{tag.displayName}}</div>
        <mat-icon (click)="removeSelected(tag)">close</mat-icon>
      </div>
      <div *ngFor="let tag of filteredTags; trackBy: trackTagById" class="menu-item" flexLayout="row"
        flexLayoutAlign="start center" (click)="addSelected(tag)">
        <div>{{tag.displayName}}</div>
      </div>
    </div>
  </div>
</ng-template>
